import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { Component, default as React } from "react";
import { View } from "../components";
import { IconButton } from "@mui/material";

export default class AumentaDiminui extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    let { value, tooltip, aumentarPosicao, diminuirPosicao } = this.props;
    return (
      <View tooltip={tooltip} style={{ flexDirection: 'row' }}>
        <IconButton
          onClick={() => {
            aumentarPosicao();
          }}
        >
          <KeyboardArrowDown />
        </IconButton>
        <span
          style={{
            alignSelf: "center",
            fontSize: "1rem",
            fontWeight: 400,
          }}
        >
          {value}
        </span>
        <IconButton
          onClick={() => {
            diminuirPosicao();
            


          }}
        >
          <KeyboardArrowUp />
        </IconButton>

      </View>
    )
  };
}

